export function isKeyboardEventFromEditableTarget(event: KeyboardEvent): boolean {
  const target = event.target;

  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (target.isContentEditable) {
    return true;
  }

  const editableElement = target.closest(
    'input, textarea, select, [contenteditable]:not([contenteditable="false"])'
  );

  return editableElement !== null;
}

export function isKeyboardEventFromEnabledEditableTarget(event: KeyboardEvent): boolean {
  const target = event.target;

  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (target.isContentEditable) {
    return true;
  }

  const editableElement = target.closest(
    'input, textarea, select, [contenteditable]:not([contenteditable="false"])'
  );

  if (
    editableElement instanceof HTMLInputElement ||
    editableElement instanceof HTMLTextAreaElement
  ) {
    return !editableElement.disabled && !editableElement.readOnly;
  }

  if (editableElement instanceof HTMLSelectElement) {
    return !editableElement.disabled;
  }

  return editableElement !== null;
}
